import React from "react";
import { Box, CircularProgress } from "@mui/material";

// MUI thickness is relative to a 44 viewBox: 4.4 gives the design's stroke of 10% of the size
const THICKNESS = 4.4;
// the arc covers 90deg including the round caps, which add (thickness / 2) on each end
const ARC_VALUE = 22;
const START_ANGLE = -83.6;

// Sizes from the design system: 32 (small), 40 (medium), 56 (large)
const CircularLoading = ({ size = 56, color = "#24233D" }) => (
  <Box
    aria-hidden="true"
    sx={{ position: "relative", width: size, height: size }}
  >
    <CircularProgress
      variant="determinate"
      value={100}
      size={size}
      thickness={THICKNESS}
      sx={{ color: "#F2F2F2", position: "absolute", inset: 0 }}
    />
    <CircularProgress
      variant="determinate"
      value={ARC_VALUE}
      size={size}
      thickness={THICKNESS}
      sx={{
        color,
        position: "absolute",
        inset: 0,
        animation: "circularLoadingSpin 1s linear infinite",
        "@keyframes circularLoadingSpin": {
          from: { transform: `rotate(${START_ANGLE}deg)` },
          to: { transform: `rotate(${START_ANGLE + 360}deg)` },
        },
        "& .MuiCircularProgress-circle": { strokeLinecap: "round" },
      }}
    />
  </Box>
);

export default CircularLoading;
